const Format = `
  id
  description
`;

export default Format;
